import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getLanguage } from '../lib/telegram';

const en = {
  translation: {
    common: {
      loading: 'Loading...',
      retry: 'Retry',
      cancel: 'Cancel',
      save: 'Save',
      confirm: 'Confirm',
      remove: 'Remove',
      add: 'Add',
    },
    nav: {
      store: 'Store',
      allSkins: 'Skins',
      favorites: 'Favorites',
      settings: 'Settings',
    },
    disclaimer: {
      title: 'Unofficial tool',
      text: 'This app is not affiliated with Riot Games. Use at your own risk — Riot can ban accounts using unofficial API clients.',
    },
    login: {
      title: 'Connect your Riot account',
      subtitle: 'Your credentials are sent directly to Riot. We only store encrypted tokens.',
      username: 'Username',
      password: 'Password',
      region: 'Region',
      signIn: 'Sign in',
      mfaTitle: 'Two-factor auth',
      mfaHint: 'Enter the code sent to {{email}}',
      mfaCode: 'Authentication code',
      errorInvalid: 'Invalid credentials',
    },
    store: {
      title: 'Your daily store',
      refreshIn: 'Refreshes in',
      refresh: 'Refresh',
      nightMarket: 'Night Market',
      empty: 'No offers available',
      favHit: 'Favorite skin in store!',
      notLinkedTitle: 'Link your Riot account',
      notLinkedCta: 'Sign in',
    },
    skins: {
      title: 'All skins',
      search: 'Search skins...',
      filterWeapon: 'Weapon',
      filterTier: 'Rarity',
      anyWeapon: 'Any weapon',
      anyTier: 'Any rarity',
      clearFilters: 'Clear',
    },
    favorites: {
      title: 'Your wishlist',
      empty: 'Tap the heart on any skin to track it here.',
      lastSeen: 'Last seen {{when}}',
      neverSeen: 'Not seen yet',
    },
    settings: {
      title: 'Settings',
      notifications: 'Telegram notifications',
      notificationsHint: 'Get a message when a favorite appears in your store',
      language: 'Language',
      account: 'Account',
      puuid: 'PUUID',
      region: 'Region',
      logout: 'Disconnect Riot account',
      logoutConfirm: 'Remove your Riot tokens? You will need to sign in again.',
    },
    time: {
      daysShort: 'd',
      hoursShort: 'h',
      minutesShort: 'm',
      secondsShort: 's',
    },
  },
};

const ru: typeof en = {
  translation: {
    common: {
      loading: 'Загрузка...',
      retry: 'Повторить',
      cancel: 'Отмена',
      save: 'Сохранить',
      confirm: 'Подтвердить',
      remove: 'Удалить',
      add: 'Добавить',
    },
    nav: {
      store: 'Магазин',
      allSkins: 'Скины',
      favorites: 'Избранное',
      settings: 'Настройки',
    },
    disclaimer: {
      title: 'Неофициальный инструмент',
      text: 'Приложение не связано с Riot Games. Используйте на свой риск — Riot может блокировать аккаунты за использование неофициальных клиентов API.',
    },
    login: {
      title: 'Подключи аккаунт Riot',
      subtitle: 'Логин и пароль отправляются напрямую в Riot. Мы храним только зашифрованные токены.',
      username: 'Логин',
      password: 'Пароль',
      region: 'Регион',
      signIn: 'Войти',
      mfaTitle: 'Двухфакторная аутентификация',
      mfaHint: 'Введи код, отправленный на {{email}}',
      mfaCode: 'Код подтверждения',
      errorInvalid: 'Неверные учётные данные',
    },
    store: {
      title: 'Твой ежедневный магазин',
      refreshIn: 'Обновится через',
      refresh: 'Обновить',
      nightMarket: 'Ночной рынок',
      empty: 'Предложения пока недоступны',
      favHit: 'Скин из избранного в магазине!',
      notLinkedTitle: 'Подключи аккаунт Riot',
      notLinkedCta: 'Войти',
    },
    skins: {
      title: 'Все скины',
      search: 'Поиск по названию...',
      filterWeapon: 'Оружие',
      filterTier: 'Редкость',
      anyWeapon: 'Любое оружие',
      anyTier: 'Любая редкость',
      clearFilters: 'Сбросить',
    },
    favorites: {
      title: 'Твой список желаний',
      empty: 'Тапни по сердечку на любом скине, чтобы отслеживать его здесь.',
      lastSeen: 'Последний раз {{when}}',
      neverSeen: 'Ещё не выпадал',
    },
    settings: {
      title: 'Настройки',
      notifications: 'Уведомления Telegram',
      notificationsHint: 'Сообщение при появлении избранного скина в магазине',
      language: 'Язык',
      account: 'Аккаунт',
      puuid: 'PUUID',
      region: 'Регион',
      logout: 'Отключить аккаунт Riot',
      logoutConfirm: 'Удалить Riot-токены? Придётся войти снова.',
    },
    time: {
      daysShort: 'д',
      hoursShort: 'ч',
      minutesShort: 'м',
      secondsShort: 'с',
    },
  },
};

const detected = getLanguage();
const initial = detected.startsWith('ru') ? 'ru' : 'en';

void i18n.use(initReactI18next).init({
  resources: { en, ru },
  lng: initial,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;
